import { Info } from './styles'

export function EmployeeInformations({ children }) {
  return <Info>{children}</Info>
}
